import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';
import Box from '../../../reusecore/Box';
import Heading from '../../../reusecore/Heading';
import Text from '../../../reusecore/Text';
import { List, ListItem } from '../../../reusecore/List';
import BlogSideBarWrapper from './blogSidebar.style';
import { flatten, uniqBy } from 'lodash';

const SideBar = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          posts: allSanityPost(filter: { slug: { current: { ne: null } } }) {
            nodes {
              ...Post
            }
          }
          categories: allSanityCategory(filter: { slug: { current: { ne: null } } }) {
            nodes {
              ...Category
            }
          }
        }
      `}
      render={({ posts, categories }) => {
        let tags = posts?.nodes.map((post) => {
          return post.tags;
        });
        tags = uniqBy(flatten(tags), 'label');
        return (
          <BlogSideBarWrapper>
            {/*<Box className="sidebar-widgets">*/}
            {/*  <Box className="search-box">*/}
            {/*    <input type="text" />*/}
            {/*    <Button>*/}
            {/*      <FaSearch />*/}
            {/*    </Button>*/}
            {/*  </Box>*/}
            {/*</Box>*/}

            {/*<Box className="sidebar-widgets recent-post">*/}
            {/*  <Box className="widgets-title">*/}
            {/*    <Heading as="h3">Latest Post</Heading>*/}
            {/*  </Box>*/}
            {/*  {recentPosts?.map((item, index) => (*/}
            {/*    <Box className="recent-post-block" key={index}>*/}
            {/*      <Image src={item.thumbnail} alt="prime-app" />*/}
            {/*      <Box className="recent-post-content-block">*/}
            {/*        <Link to={item.url}>*/}
            {/*          <Heading as="h3">{`${item.title}`} </Heading>*/}
            {/*        </Link>*/}
            {/*        <Box className="post-meta-block">*/}
            {/*          By: <Link to="#"> Admin </Link>*/}
            {/*          <Link to="#"> Dec, 07 </Link>*/}
            {/*        </Box>*/}
            {/*      </Box>*/}
            {/*    </Box>*/}
            {/*  ))}*/}
            {/*</Box>*/}

            <Box className="sidebar-widgets category">
              <Box className="widgets-title">
                <Heading as="h3">Categories</Heading>
              </Box>
              <List>
                {categories?.nodes.map((category, i) => (
                  <ListItem key={i}>
                    <Link to={`/blog?category=${category.slug.current}`}>
                      <Text as="span">{category.title}</Text>
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Box>

            <Box className="sidebar-widgets tags">
              <Box className="widgets-title">
                <Heading as="h3">Tags</Heading>
              </Box>

              <List>
                {tags?.map((tag, index) => {
                  // hack to remove sanity tag Create being saved in label
                  // https://github.com/rosnovsky/sanity-plugin-autocomplete-tags/issues/14
                  let displayTag = tag.label;
                  const createIndex = displayTag.indexOf('Create "');
                  if (createIndex !== -1) {
                    displayTag = displayTag.substring(8, displayTag.length - 1);
                  }
                  return (
                    <ListItem key={index}>
                      <Link to={`/blog?tag=${tag.value.toLowerCase()}`}>
                        <Text as="span">{displayTag.toLowerCase()}</Text>{' '}
                      </Link>
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          </BlogSideBarWrapper>
        );
      }}
    />
  );
};

export default SideBar;
